import React from 'react';
import cx from 'classnames';
import Icon from '../Icon/Icon';
var css = {
  "cardCarousel": "rui-DCegA",
  "imageContainer": "rui-02zKQ",
  "tags": "rui-ucRqr",
  "image": "rui-3oTCk",
  "cardContent": "rui-L0oW9",
  "title": "rui-djiDz",
  "subtitle": "rui-osTUF",
  "body": "rui-BxNHw"
};
export var NewCardCarouselBig = function NewCardCarouselBig(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    installment = _ref.installment,
    body = _ref.body,
    image = _ref.image,
    tags = _ref.tags,
    icon = _ref.icon,
    iconSize = _ref.iconSize,
    onIconClick = _ref.onIconClick,
    iconColor = _ref.iconColor,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(css.cardCarousel, className)
  }, image && /*#__PURE__*/React.createElement("div", {
    className: css.imageContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: image.src,
    alt: image.alt,
    className: css.image
  }), !!(tags && tags.length) && /*#__PURE__*/React.createElement("div", {
    className: css.tags
  }, tags)), /*#__PURE__*/React.createElement("div", {
    className: css.cardContent
  }, title && /*#__PURE__*/React.createElement("div", {
    className: css.title
  }, title, icon && /*#__PURE__*/React.createElement("div", {
    onClick: onIconClick,
    className: css.iconContainer,
    onKeyPress: onIconClick,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    size: iconSize,
    color: iconColor
  }))), subtitle && /*#__PURE__*/React.createElement("div", {
    className: css.subtitle
  }, subtitle), installment && installment(), body && /*#__PURE__*/React.createElement("div", {
    className: css.body
  }, body)));
};
NewCardCarouselBig.defaultProps = {
  iconSize: 20,
  className: ''
};
export default NewCardCarouselBig;